export default "__VITE_ASSET__fa06161a__"